const _contact = {
	title: '¿Nos ponemos a ello?',
	subtitle: '',
	description: '',
	items: [
		{
			id: 1,
			isEmail: false,
			isFirst: true,
			isLast: false,
			icon: 'phone-square',
			name: 'Sergio Carmona',
			channel: '34 635 605 261'
		},
		{
			id: 2,
			isEmail: true,
			isFirst: false,
			isLast: false,
			icon: 'envelope-square',
			name: 'OnFocus Media S.L.',
			channel: ['info', 'onfocusmedia', 'com']
		},
		{
			id: 3,
			isEmail: false,
			isFirst: false,
			isLast: true,
			icon: 'phone-square',
			name: 'Hugo Carmona',
			channel: '34 649 092 537'
		}
	]
}

export default {
	getData(callback) {
		callback(_contact)
	}
}
